import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdminSpaceComponent } from "./admin-space/admin-space.component";
import { AuthGuard } from "./auth/auth.guard";
import { ExternalCompaniesOverviewComponent } from "./admin-space/external-companies-overview/external-companies-overview.component";
import { VesselOperatorSpaceComponent } from "./vessel-operator-space/vessel-operator-space.component";
import { WarehouseOverviewComponent } from "./service-provider-space/warehouse-overview/warehouse-overview.component";
import { VesselsOverviewComponent } from "./vessel-operator-space/vessels-overview/vessels-overview.component";
import { ShowVesselComponent } from "./vessel-operator-space/show-vessel/show-vessel.component";
import { ShowLocationComponent } from "./vessel-operator-space/show-vessel/show-location/show-location.component";
import { UnassignedComponentsOverviewComponent } from "./vessel-operator-space/unassigned-components-overview/unassigned-components-overview.component";
import { PrintPdfComponent } from "./print-pdf/print-pdf.component";
import { AdminGuard } from "./auth/admin.guard";
import { VesselOwnerGuard } from "./auth/vessel-owner.guard";
import { Co2LightComponent } from "./service-provider-space/co2-light/co2-light.component";
import { MobileOverviewComponent } from './mobile-overview/mobile-overview.component';
import { OneTimeRedirectionComponent } from "./service-provider-space/screening-overview/one-time-redirection/one-time-redirection.component";
import { DashboardComponent } from "./admin-space/dashboard/dashboard.component";
import { AcademyAdminComponent } from "./admin-space/academy-admin/academy-admin.component";
import { MasterSheetComponent } from "./admin-space/master-sheet/master-sheet.component";
import { DatabaseOverviewComponent } from "./admin-space/master-sheet/database-overview/database-overview.component";
import { GroupsOverviewComponent } from "./admin-space/master-sheet/groups-overview/groups-overview.component";
import { SubGroupsOverviewComponent } from "./admin-space/master-sheet/sub-groups-overview/sub-groups-overview.component";
import { EndGroupsOverviewComponent } from "./admin-space/master-sheet/end-groups-overview/end-groups-overview.component";
import { ProcessesOverviewComponent } from "./admin-space/master-sheet/processes-overview/processes-overview.component";
import { SalesSpaceComponent } from "./sales-space/sales-space.component";
import { SalesOverviewComponent } from "./sales-space/sales-overview/sales-overview.component";
import { ValidationDashboardComponent } from "./admin-space/validation-dashboard/validation-dashboard.component";
import { SalesGuard } from "./auth/sales.guard";
import { ValidationReviewComponent } from "./admin-space/validation-dashboard/validation-review/validation-review.component";
import { EngineersSpaceComponent } from "./engineers-space/engineers-space.component";
import { EngineersGuard } from "./auth/engineers.guard";
import { PublicAssessmentComponent } from "./service-provider-space/share-overview/public-assessment/public-assessment.component";
import { CompanyAssessmentDataComponent } from "./admin-space/company-assessment-data/company-assessment-data.component";
import { DatabasesComponent } from "./admin-space/company-assessment-data/databases/databases.component";
import { CompanyAssessmentGroupsComponent } from "./admin-space/company-assessment-data/company-assessment-groups/company-assessment-groups.component";
import { CompanyAssessmentSubGroupsComponent } from "./admin-space/company-assessment-data/company-assessment-sub-groups/company-assessment-sub-groups.component";
import { CompanyAssessmentEndGroupsComponent } from "./admin-space/company-assessment-data/company-assessment-end-groups/company-assessment-end-groups.component";
import { CompanyAssessmentProcessComponent } from "./admin-space/company-assessment-data/company-assessment-process/company-assessment-process.component";
import { QuimaUsageComponent } from "./admin-space/quima-usage/quima-usage.component";
import { FuelListComponent } from "./admin-space/vessel/fuel-list/fuel-list.component";
import { CompaniesListV2Component } from "./admin-space/companies-v2/companies-list-v2/companies-list-v2.component";
import { V2loginComponent } from "./v2login/v2login.component";
import { RedirectionComponent } from "./new-login/redirection/redirection.component";
import { GuestGuard } from "./auth/guest.guard";
import { ScenarioCategoryListComponent } from "./admin-space/scenario-category/scenario-category-list/scenario-category-list.component";
import { ScenarioCategoryCreateComponent } from "./admin-space/scenario-category/scenario-category-create/scenario-category-create.component";
import { ScenarioCategoryUpdateComponent } from "./admin-space/scenario-category/scenario-category-update/scenario-category-update.component";
import { FuelOptionListComponent } from "./admin-space/fuel-option/fuel-option-list/fuel-option-list.component";
import { FuelOptionCreateComponent } from "./admin-space/fuel-option/fuel-option-create/fuel-option-create.component";
import { FuelOptionEditComponent } from "./admin-space/fuel-option/fuel-option-edit/fuel-option-edit.component";
import { RecyclingComponent } from "./service-provider-space/vessels/recycling/recycling.component";
import { RecyclingOptionsComponent } from "./admin-space/recycling-option/recycling-options/recycling-options.component";
import { RecyclingOptionCreateComponent } from "./admin-space/recycling-option/recycling-option-create/recycling-option-create.component";
import { RecyclingOptionEditComponent } from "./admin-space/recycling-option/recycling-option-edit/recycling-option-edit.component";
import { SteelSourceOptionsListComponent } from "./admin-space/steel-source-option/steel-source-options-list/steel-source-options-list.component";
import { SteelSourceOptionsCreateComponent } from "./admin-space/steel-source-option/steel-source-options-create/steel-source-options-create.component";
import { SteelSourceOptionsEditComponent } from "./admin-space/steel-source-option/steel-source-options-edit/steel-source-options-edit.component";
import { EnergyOptionsComponent } from "./admin-space/energy-option/energy-options/energy-options.component";
import { EnergyOptionCreateComponent } from "./admin-space/energy-option/energy-option-create/energy-option-create.component";
import { EnergyOptionEditComponent } from "./admin-space/energy-option/energy-option-edit/energy-option-edit.component";
import { CompaniesService } from "./services/yardscore-services/companies.service";
import { CompaniesEditV2Component } from "./admin-space/companies-v2/companies-edit-v2/companies-edit-v2.component";
import { CompanyUsersListComponent } from "./admin-space/companies-v2/company-users-list/company-users-list.component";
import { CreateCompanyUserComponent } from "./admin-space/companies-v2/create-company-user/create-company-user.component";
import { EditCompanyUserComponent } from "./admin-space/companies-v2/edit-company-user/edit-company-user.component";
import { CompanyCreateComponent } from "./admin-space/companies-v2/company-create/company-create.component";
import { UsersListV2Component } from "./admin-space/companies-v2/users-list-v2/users-list-v2.component";
import { VesselSubgroupListComponent } from "./admin-space/vessel-subgroups/vessel-subgroup-list/vessel-subgroup-list.component";
import { VesselSubgroupCreateComponent } from "./admin-space/vessel-subgroups/vessel-subgroup-create/vessel-subgroup-create.component";
import { VesselSubgroupUpdateComponent } from "./admin-space/vessel-subgroups/vessel-subgroup-update/vessel-subgroup-update.component";


const routes: Routes = [
  {
    path: "",
    component: V2loginComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "v2/auth/validate",
    component: RedirectionComponent,
  },
  {
    path: "login",
    component: V2loginComponent,
    canActivate: [GuestGuard]
  },
  {
    path: "redirection",
    component: RedirectionComponent,
  },
  {
    path: "public-assessment/:sharingId",
    component: PublicAssessmentComponent,
  }, {
    path: "sales-space",
    component: SalesSpaceComponent,
    children: [
      { path: "", component: SalesOverviewComponent },
      { path: "sales-overview", component: SalesOverviewComponent },
    ]
  },
  {
    path: "onetimeredirection",
    component: OneTimeRedirectionComponent,
  },
  {
    path: "print/:id",
    component: PrintPdfComponent,
  },
  {
    path: "mobile",
    component: MobileOverviewComponent,
  }, {
    path: "homeAdmin",
    component: AdminSpaceComponent,
    canActivate: [AuthGuard, AdminGuard],
    children: [
      { path: "", component: CompaniesListV2Component },
      { path: "v2/fuelAndRecyclingOption", component: FuelListComponent },
      { path: "v2/companies", component: CompaniesListV2Component },
      { path: "v2/users", component: UsersListV2Component },
      { path: 'v2/companies/create', component: CompanyCreateComponent, },
      { path: 'v2/companies/:id', component: CompaniesEditV2Component, },
      { path: 'v2/companies/create-company-user/:id', component: CreateCompanyUserComponent },
      {
        path: 'v2/companies/:companyId/users/:userId/edit',
        component: EditCompanyUserComponent
      },
      
      { path: 'v2/companies/:id/users', component: CompanyUsersListComponent },
      { path: "v2/scenarioCategory", component: ScenarioCategoryListComponent },
      { path: "v2/scenarioCategory/create", component: ScenarioCategoryCreateComponent },
      { path: 'v2/scenarioCategory/edit/:id', component: ScenarioCategoryUpdateComponent },
      { path: "v2/fuelOptions", component: FuelOptionListComponent },
      { path: "v2/fuelOption/create", component: FuelOptionCreateComponent },
      { path: 'v2/fuelOption/edit/:id', component: FuelOptionEditComponent },
      { path: "v2/recyclingOptions", component: RecyclingOptionsComponent },
      { path: "v2/recyclingOption/create", component: RecyclingOptionCreateComponent },
      { path: 'v2/recyclingOption/edit/:id', component: RecyclingOptionEditComponent },
      { path: "v2/steelSourceOptions", component: SteelSourceOptionsListComponent },
      { path: "v2/steelSourceOption/create", component: SteelSourceOptionsCreateComponent },
      { path: 'v2/steelSourceOption/edit/:id', component: SteelSourceOptionsEditComponent },
      { path: "v2/vesselSubgroup", component: VesselSubgroupListComponent },
      { path: "v2/vesselSubgroup/create", component: VesselSubgroupCreateComponent },
      { path: 'v2/vesselSubgroup/edit/:vesselType/:subType', component: VesselSubgroupUpdateComponent },






      { path: "v2/energyOptions", component: EnergyOptionsComponent },
      { path: "v2/energyOption/create", component: EnergyOptionCreateComponent },
      { path: "v2/energyOption/edit/:id", component: EnergyOptionEditComponent },

      { path: "dashboard", component: DashboardComponent },
      { path: "admin-academy", component: AcademyAdminComponent },
      { path: "project/:screeningId", component: ValidationReviewComponent },

      {
        path: "homeServiceProvider/:companyId",
        loadChildren: () => import('./service-provider-space/service-provider-space.module').then(m => m.ServiceProviderSpaceModule)
      },
      {
        path: "external-companies",
        component: ExternalCompaniesOverviewComponent,
      },

      {
        path: "Validation-dashboard",
        component: ValidationDashboardComponent,
        children: [

        ]
      },
      {
        path: "quima-usage",
        component: QuimaUsageComponent,
        children: [

        ]
      },
      {
        path: "mastersheet",
        component: MasterSheetComponent,
        children: [
          { path: "databases", component: DatabaseOverviewComponent },
          { path: "databases/:inventoryId", component: GroupsOverviewComponent },
          { path: "sub-groups/:groupId", component: SubGroupsOverviewComponent },
          { path: "end-groups/:subGroupId", component: EndGroupsOverviewComponent },
          { path: "processes/:endGroupId", component: ProcessesOverviewComponent },
        ]
      },
      {
        path: "company-assessment-data",
        component: CompanyAssessmentDataComponent,
        children: [
          { path: "databases", component: DatabasesComponent },
          { path: "databases/:inventoryId", component: CompanyAssessmentGroupsComponent },
          { path: "sub-groups/:groupId", component: CompanyAssessmentSubGroupsComponent },
          { path: "end-groups/:subGroupId", component: CompanyAssessmentEndGroupsComponent },
          { path: "processes/:endGroupId", component: CompanyAssessmentProcessComponent },
        ]
      },
    ],
  },
  {
    path: "homeServiceProvider/:companyId",
    loadChildren: () => import('./service-provider-space/service-provider-space.module').then(m => m.ServiceProviderSpaceModule)
  },
  {
    path: "homeVesselOperator/:companyId",
    component: VesselOperatorSpaceComponent,
    canActivate: [AuthGuard, VesselOwnerGuard],
    children: [
      { path: "", component: VesselsOverviewComponent },
      { path: "components", component: UnassignedComponentsOverviewComponent },
      { path: "vessels", component: VesselsOverviewComponent },
      { path: "vessels/:vesselId", component: ShowVesselComponent },
      { path: "location/:locationId", component: ShowLocationComponent },
      { path: "warehouses", component: WarehouseOverviewComponent },
      { path: "co2", component: Co2LightComponent },
    ],
  },
  {
    path: "homeSales",
    component: SalesSpaceComponent,
    canActivate: [AuthGuard, SalesGuard],
    children: [
      { path: "sales-space-overview", component: SalesOverviewComponent },
    ],
  },
  {
    path: "homeEngineers",
    component: EngineersSpaceComponent,
    canActivate: [AuthGuard, EngineersGuard],
    children: [
      { path: "", component: ValidationDashboardComponent },
      { path: "validation", component: ValidationDashboardComponent },
      { path: "master-sheet", component: MasterSheetComponent },
      { path: "databases", component: DatabaseOverviewComponent },
      { path: "databases/:inventoryId", component: GroupsOverviewComponent },
      { path: "sub-groups/:groupId", component: SubGroupsOverviewComponent },
      { path: "end-groups/:subGroupId", component: EndGroupsOverviewComponent },
      { path: "processes/:endGroupId", component: ProcessesOverviewComponent },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }